/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as PContact from "./../../common/models";
export interface ITGenerateContactInfoUrlRequestArgs {
    contactId?: string;
}
export class TGenerateContactInfoUrlRequest {
    public contactId?: string;
    constructor(args?: ITGenerateContactInfoUrlRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGenerateContactInfoUrlRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGenerateContactInfoUrlRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.contactId = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGenerateContactInfoUrlRequest(_args);
    }
}
export interface ITGenerateContactInfoUrlResponseArgs {
    url: string;
}
export class TGenerateContactInfoUrlResponse {
    public url: string;
    constructor(args: ITGenerateContactInfoUrlResponseArgs) {
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[url] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGenerateContactInfoUrlResponse");
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGenerateContactInfoUrlResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_2: string = input.readString();
                        _args.url = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.url !== undefined) {
            return new TGenerateContactInfoUrlResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGenerateContactInfoUrlResponse from input");
        }
    }
}
export interface ITSubmitContactInfoRequestArgs {
    token: string;
    submittedContact: PContact.TAppContact;
}
export class TSubmitContactInfoRequest {
    public token: string;
    public submittedContact: PContact.TAppContact;
    constructor(args: ITSubmitContactInfoRequestArgs) {
        if (args != null && args.token != null) {
            this.token = args.token;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[token] is unset!");
        }
        if (args != null && args.submittedContact != null) {
            this.submittedContact = args.submittedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[submittedContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSubmitContactInfoRequest");
        if (this.token != null) {
            output.writeFieldBegin("token", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.token);
            output.writeFieldEnd();
        }
        if (this.submittedContact != null) {
            output.writeFieldBegin("submittedContact", thrift.Thrift.Type.STRUCT, 2);
            this.submittedContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSubmitContactInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.token = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_4: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.submittedContact = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.token !== undefined && _args.submittedContact !== undefined) {
            return new TSubmitContactInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSubmitContactInfoRequest from input");
        }
    }
}
export interface ITSubmitContactInfoResponseArgs {
}
export class TSubmitContactInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSubmitContactInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSubmitContactInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSubmitContactInfoResponse();
    }
}
